// Provides access to values of search params by keys
// TODO: Document it
class URLParams {

  constructor() {
    this.updateValues = this.updateValues.bind(this);

    this.get = this.get.bind(this);

    this.updateValues();
  }
  
  updateValues() {
    this.values = {};

    let search = window.location.search || "";

    if (search[0] == "?") {
      search = search.slice(1);
    }

    search.split("&").forEach((pairString) => {
      let parts = pairString.split("=");
      if(!parts[0]) {
        return;
      }
      let key = decodeURIComponent(parts[0]);
      let value = decodeURIComponent(parts[1]);

      if(key.endsWith("[]")) {
        key = key.replace("[]", "");
        let curArray = this.values[key] || [];
        curArray.push(value);
        this.values[key] = curArray
      }
      else {
        this.values[key] = value;
      }
    });
  }

  get(key) {
    this.updateValues();
    return this.values[key];
  }

  getValues() {
    this.updateValues();
    return this.values;
  }

  constructSearch(params, prefix) {
    let search = [], param;
    for (param in params) {
      if (params.hasOwnProperty(param)) {
        let key = prefix ? `${prefix}[${Number.isInteger(Number(param)) ? "" : param}]` : param;
        let value = params[param];
        if(value) {
          if(typeof value === "object") {
            search.push(this.constructSearch(value, key));
          }
          else {
            search.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
          }
        }
      }
    }
    return search.join("&");
  }
}

const urlParams = new URLParams();
export default urlParams;